import { useSelector } from 'react-redux';
import { sliceKeys, selectors } from '../../model';
import { useRegionsQuery, regionsSelectors } from '../../api/regions';
import { getBaseOptions } from './helpers';

const { selectCurrentId: selectCompanyId } = selectors[sliceKeys.companies];
const { selectCurrentId: selectCityId } = selectors[sliceKeys.cities];

export const dataTypes = {
  original: 'original',
  options: 'options',
};

const _options = {
  [dataTypes.original]: {},
  [dataTypes.options]: { select: regionsSelectors.toSelectOption },
};

export const useRegionsData = ({ options, dataType } = {}) => {
  const serviceCompanyId = useSelector(selectCompanyId);

  const cityId = useSelector(selectCityId);

  const baseOptions = getBaseOptions(_options, dataType, dataTypes.original);

  return useRegionsQuery({
    params: { serviceCompanyId, cityId },
    options: { ...baseOptions, ...options },
  });
};

useRegionsData.dataTypes = dataTypes;
